import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ReadContainer from '@mail/containers/ReadContainer.vue'
import MoveModal from '@mail/components/Modals/MoveModal.vue'
import api from '@mail/api'
import * as types from '@mail/store/types'
import { mapGetters } from 'vuex'
import { DeleteMode } from '../types'
@Component({
    components: { PageViewHeaderWithActionBar, ReadContainer, MoveModal },
    computed: mapGetters({
        currentEmail: types.EMAIL_CURRENT
    })
})
export default class ReadView extends Vue {

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    currentEmail!: mail.EmailMessage

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    
    openDropdown: boolean = false
    moveModalShow: boolean = false

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    async deleteItem() {
        const item = this.currentEmail
        const ids = [item.id]

        if (await(window as any).confirmAsync(this.$t('메일을_삭제하시겠습니까').toString()) == false) {
            return false
        } else {
            api.mail.delete({ ids, mode: DeleteMode.MoveToDeletedItems}).then(async (succeed) => {
                if (succeed) {
                    item.deleted = true
                    this.$router.push('/mail/list')
                } else {
                    item.deleted = false
                    await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
                }
            }).catch(async () => {
                item.deleted = false
                await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
            })
        }
    }

    moveItem() {
        this.moveModalShow = true
    }
}
